import React from 'react';
import GridFilter from 'components/layouts/Account/GridFilter';

const SortAccountsFilter = ({
  label,
  change,
  filterState: { selection, options }
}) => (
  <GridFilter
    label={label}
    options={options}
    change={change}
    className={'sort-element'}
    selection={selection}
  />
);

export default SortAccountsFilter;
